module.exports = __webpack_public_path__ + "img/TECNOLOGIA-CIAZ-1.143e9bd4.jpg";